<template>
  <div class='wca-login-portal'>
    <h1>Logging in through WCA...</h1>
    <h4>This shouldn't take long. If it does, contact cuberslivetpc@gmail.com with a subject line starting with [BUG]</h4>
  </div>
</template>

<script>
import UsersService from '@/services/UsersService'
export default {
  name: 'wca-login-portal',
  data () { return {} },
  async mounted () {
    let response = await UsersService.getToken({path: this.$route.query.path || '/'}, 'wca')
    console.log(response.data)
    if (response.data.error === 'badLoginAuth') {
      window.open(`${this.$backendApi}/auth/wca`, '_self')
      return
    }
    if (response.data.success === true) {
      this.$store.commit('setSolverId', response.data.user._id)
      this.$store.commit('setSolver', response.data.user.username)
      this.$store.commit('setGlobalAuthToken', response.data.authToken)

      localStorage.setItem('globalSolver', this.$store.state.solver)
      localStorage.setItem('globalSolverId', this.$store.state.solverId)
      localStorage.setItem('globalAuthToken', this.$store.state.globalAuthToken)
      this.$router.push({ path: response.data.redirectTo })
    } else {
      alert('Failed to login due to error: ' + response.data.error)
    }
  }
}
</script>
